<template>
  <OurPage :title="$t('title.survey.edit')" :back-route="backRoute" width="md">
    <DeleteModal
      :title="$t('title.survey.delete')"
      :delete-confirm="$t('title.survey.deleteConfirm', { title: form.title })"
      :show.sync="isShownDeleteModal"
      :user-id="surveyId"
      :name="form.title"
      :mutation="deleteSurveyMutation()"
      @deleteUser="goToList"
    />
    <SurveyForm ref="surveyForm" v-model="form" />
    <template #footer-left>
      <OurButton
        v-if="getPermission['survey.update']"
        class="button"
        :text="$t('button.save')"
        @click="onClickSaveButton"
      />

      <OurLink :route="backRoute">
        <OurButton class="button" :text="$t('button.back')" variant="secondary" />
      </OurLink>
    </template>

    <template #footer-right>
      <OurButton
        v-if="getPermission['survey.delete']"
        class="button"
        variant="thirdary"
        :text="$t('button.remove')"
        @click="onClickDeleteButton"
      />
    </template>
  </OurPage>
</template>

<script>
import DeleteModal from "@/components/modals/DeleteModal.vue";
import apolloMixin from "@/mixins/apollo.mixin";
import { mapGetters } from "vuex";
import { surveyQuery } from "@/views/settings/survey/edit/gql/queries";
import SurveyForm from "@/views/settings/survey/add/_components/SurveyForm.vue";
import {
  deleteSurveyMutation,
  updateSurveyMutation,
} from "@/views/settings/survey/edit/gql/mutations";

export default {
  name: "SurveyEdit",
  components: { SurveyForm, DeleteModal },
  mixins: [apolloMixin],
  data() {
    return {
      isShownDeleteModal: false,
      backRoute: {
        name: "SettingsSurvey",
        title: this.$t("title.survey._"),
      },
      form: {
        title: "",
        text: "",
        url: "",
        startsAt: null,
        endsAt: null,
        maxShows: 1,
      },
    };
  },
  computed: {
    ...mapGetters("user", ["getPermission"]),
    surveyId() {
      return this.$route.params.id;
    },
  },
  created() {
    this.getData();
  },
  methods: {
    deleteSurveyMutation() {
      return deleteSurveyMutation;
    },
    goToList() {
      this.$router.push({ name: "SettingsSurvey" });
    },
    onClickDeleteButton() {
      this.isShownDeleteModal = true;
    },
    async getData() {
      const { survey } = await this.$get(surveyQuery, { surveyId: this.surveyId });

      if (survey) {
        const { title, text, url, startsAt, endsAt, maxShows } = survey;

        this.form = {
          id: this.surveyId,
          title,
          text,
          url,
          startsAt: parseInt(startsAt, 10),
          endsAt: parseInt(endsAt, 10),
          maxShows: maxShows ?? 1,
        };
      }
    },
    async onClickSaveButton() {
      this.$refs.surveyForm.emitForm();

      if (!this.form.isValid) {
        return;
      }

      const { title, text, url, startsAt, endsAt, maxShows } = this.form;

      const { updateSurvey } = await this.$post(
        updateSurveyMutation,
        {
          id: this.surveyId,
          title,
          text,
          url,
          startsAt,
          endsAt,
          maxShows,
        },
        {
          delaySuccessNotify: true,
        }
      );

      if (updateSurvey?.id) {
        this.goToList();
      }
    },
  },
};
</script>
